/* ===================================================================
   OSTAJATYYPPI  →  assets/buyer-type.js
   Kytkin "Ostan yrityksenä" + Y-tunnus. Tallentaa korin attribuutteihin,
   estää kassalle-siirtymän kunnes yritysasiakkaan Y-tunnus on kelvollinen.

   - Toimii sekä drawerissa (data-context="drawer") että koripohjalla ("page").
   - Molemmat kontekstit synkronoidaan yhteisen tilan kautta.
   - Event-delegaatio dokumenttitasolla → kestää drawerin innerHTML-swapit.
   - Kirjoitus: POST /cart/update.js { attributes: {...} } (Shopify-natiivi).
   =================================================================== */
(function () {
  'use strict';

  // Suomalainen Y-tunnus: 7 numeroa + väliviiva + tarkistusnumero.
  var VAT_RE = /^\d{7}-\d$/;

  var state = {
    company: false,
    vat: ''
  };

  function isValidVat(v) {
    return VAT_RE.test((v || '').trim());
  }

  // Onko kori RFQ-tilassa? Silloin ostajatyyppi piilotetaan (Y-tunnus tulee lomakkeelta).
  function cartIsRfq(cart) {
    return !!(window.RFQ && window.RFQ.cartHasQuote(cart));
  }

  // Kaikki ostajatyyppi-lohkot (drawer + page).
  function blocks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-buyer]'));
  }

  // Peilaa tila kaikkiin UI-lohkoihin (ilman että laukaistaan tallennusta).
  function reflect() {
    blocks().forEach(function (b) {
      var sw = b.querySelector('[data-buyer-switch]');
      var vatWrap = b.querySelector('[data-buyer-vat]');
      var vatInput = b.querySelector('[data-buyer-vat-input]');
      var err = b.querySelector('[data-buyer-vat-err]');
      b.classList.toggle('buyer--company', state.company);
      if (sw) sw.checked = state.company;
      if (vatWrap) {
        vatWrap.classList.toggle('is-open', state.company);
        vatWrap.setAttribute('aria-hidden', state.company ? 'false' : 'true');
      }
      if (vatInput && document.activeElement !== vatInput) vatInput.value = state.vat;
      if (err) err.hidden = !(state.company && state.vat !== '' && !isValidVat(state.vat));
    });
    gateCheckout();
  }

  // Kassalle sallittu jos: ei yritys, TAI yritys + kelvollinen Y-tunnus.
  function checkoutAllowed() {
    if (!state.company) return true;
    return isValidVat(state.vat);
  }

  // Estä/salli kaikki kassanapit (merkitty data-checkout-gate).
  function gateCheckout() {
    var allowed = checkoutAllowed();
    document.querySelectorAll('[data-checkout-gate]').forEach(function (el) {
      // Linkki (drawer): estä klikkaus luokalla; nappi: disabloi.
      if (el.tagName === 'A') {
        el.classList.toggle('is-blocked', !allowed);
        el.setAttribute('aria-disabled', allowed ? 'false' : 'true');
      } else {
        el.disabled = !allowed;
      }
    });
  }

  // Tallenna tila korin attribuutteihin.
  var saveTimer = null;
  function persist() {
    if (saveTimer) clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Ostaja': state.company ? 'Yritys' : 'Kuluttaja',
            'Y-tunnus': state.company ? state.vat : ''
          }
        })
      }).catch(function () { /* hiljainen — UI-tila säilyy joka tapauksessa */ });
    }, 250);
  }

  // Alusta tila DOM:ista (server-side render sisältää korin attribuutit).
  function initFromDom() {
    var b = document.querySelector('[data-buyer]');
    if (!b) return;
    var sw = b.querySelector('[data-buyer-switch]');
    var vatInput = b.querySelector('[data-buyer-vat-input]');
    state.company = !!(sw && sw.checked);
    state.vat = vatInput ? vatInput.value : '';
    gateCheckout();
  }

  /* ---------- Tapahtumat (delegoitu) ---------- */
  document.addEventListener('change', function (e) {
    var sw = e.target.closest('[data-buyer-switch]');
    if (!sw) return;
    state.company = sw.checked;
    if (!state.company) state.vat = '';
    reflect();
    persist();
    // Fokusoi Y-tunnuskenttään kun yritys valitaan (nopeampi täyttää).
    if (state.company) {
      var b = sw.closest('[data-buyer]');
      var vi = b && b.querySelector('[data-buyer-vat-input]');
      if (vi) vi.focus();
    }
  });

  document.addEventListener('input', function (e) {
    var vi = e.target.closest('[data-buyer-vat-input]');
    if (!vi) return;
    state.vat = vi.value;
    // Peilaa toiseen kontekstiin + virheviesti + gate, mutta älä siirrä fokusta.
    blocks().forEach(function (b) {
      var other = b.querySelector('[data-buyer-vat-input]');
      if (other && other !== vi) other.value = state.vat;
      var err = b.querySelector('[data-buyer-vat-err]');
      if (err) err.hidden = !(state.company && state.vat !== '' && !isValidVat(state.vat));
    });
    gateCheckout();
    persist();
  });

  // Estä kassalle-linkin (drawer) navigointi jos ei sallittu.
  document.addEventListener('click', function (e) {
    var gate = e.target.closest('[data-checkout-gate]');
    if (!gate) return;
    if (!checkoutAllowed()) {
      e.preventDefault();
      e.stopPropagation();
      // Näytä virhe + fokusoi Y-tunnukseen.
      blocks().forEach(function (b) {
        var err = b.querySelector('[data-buyer-vat-err]');
        if (err && state.company) err.hidden = false;
      });
      var b = document.querySelector('[data-buyer].buyer--company [data-buyer-vat-input], [data-buyer] [data-buyer-vat-input]');
      if (b) b.focus();
    }
  }, true); // capture: ehdi ennen muita klikkikäsittelijöitä (esim. cart-form submit)

  // Drawer rakentaa footerin uudelleen fetchin jälkeen → varmista gate + tila.
  document.addEventListener('rfq:cleared', function () { state.company = false; state.vat = ''; reflect(); });

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  ready(function () {
    initFromDom();
    // Kun drawer avautuu ja renderöi footerin, DOM voi vaihtua → tarkista pian.
    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble')) setTimeout(initFromDom, 400);
    });
  });

  window.BuyerType = {
    checkoutAllowed: checkoutAllowed,
    isValidVat: isValidVat,
    state: state,
    refresh: initFromDom,
    setCompany: function (on) {
      state.company = !!on;
      if (!state.company) state.vat = '';
      reflect();
      persist();
    }
  };
})();
